<div class="fix-action-dialog">
	<h1 mat-dialog-title>{{content.title}}</h1>

	<mat-dialog-content fxLayout="column">
		<div class="description-text">{{content.description}}</div>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="column" fxLayoutAlign="space-around">
		<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-raised-button><span translate>キャンセル</span></button>
		</div>
		<mat-divider style="margin:8px;"></mat-divider>
		<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
			<button (click)="onAccept()" [disabled]="isProgress" color="primary" mat-raised-button>OK</button>
		</div>
	</mat-dialog-actions>

</div>
